import type { Policy } from "./Policy";

export class InvoiceCommission {
    id: string;
    persCode: string;
    persType: string;
    billMethod: Policy.BillMethod;
    percentage: number;
    commissionAmount: number;
    commissionablePremiumAmount: number;
    creditSplitPercentage?: number;
    creditAmount: number;
    creditOverride: boolean;
    changedDate: Date;
    enteredDate: Date;
}
